var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$route.meta.layout || 'default-layout',{tag:"component"},[_c('router-view'),(_vm.isAuthenticated)?_c('feedback-prompt-dialog'):_vm._e(),(_vm.isAuthenticated)?_c('document-name-conflicts-dialog'):_vm._e(),(_vm.isAuthenticated)?_c('document-upload-tray'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }